import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Grid } from '@mui/material';

export default function NationalitySelect({ setValue, selectedCode, readonly }) {

    const index = nationalities.findIndex(element => { return (element.code == selectedCode) });

    return (
        <Autocomplete
            size="small"
            id="country-select-demo"
            value={nationalities[index] || null}
            options={nationalities}
            getOptionLabel={(option) => option.label}
            style={{ minWidth: '100%', borderRadius: '30px' }}
            onChange={(event, newInputValue) => {
                setValue(newInputValue.code);
            }}
            renderOption={(props, option) => (
                <Box  {...props} >
                    <Grid container spacing={1}>
                        <Grid item xs={2}>
                            <img
                                loading="lazy"
                                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                                alt=""
                            />
                        </Grid>
                        <Grid item xs={10}>
                            {option.label} ({option.code})
                        </Grid>
                    </Grid>
                </Box>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    className='form-control'
                    disabled={readonly}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password',
                    }}>
                </TextField>
            )}
        />
    );
}

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
const nationalities = [
    { code: 'AD', label: 'Andorran', phone: '376' },
    {
        code: 'AE',
        label: 'Emirati',
        phone: '971',
    },
    { code: 'AF', label: 'Afghan', phone: '93' },
    {
        code: 'AG',
        label: 'Antiguan or Barbudan',
        phone: '1-268',
    },
    { code: 'AI', label: 'Anguillan', phone: '1-264' },
    { code: 'AL', label: 'Albanian', phone: '355' },
    { code: 'AM', label: 'Armenian', phone: '374' },
    { code: 'AO', label: 'Angolan', phone: '244' },
    { code: 'AQ', label: 'Antarctic', phone: '672' },
    { code: 'AR', label: 'Argentinian', phone: '54' },
    { code: 'AS', label: 'American Samoan', phone: '1-684' },
    { code: 'AT', label: 'Austrian', phone: '43' },
    {
        code: 'AU',
        label: 'Australian',
        phone: '61',
        suggested: true,
    },
    { code: 'AW', label: 'Aruban', phone: '297' },
    { code: 'AX', label: 'Alland Island', phone: '358' },
    { code: 'AZ', label: 'Azerbaijani', phone: '994' },
    {
        code: 'BA',
        label: 'Bosnian or Herzegovinian',
        phone: '387',
    },
    { code: 'BB', label: 'Barbadian', phone: '1-246' },
    { code: 'BD', label: 'Bangladeshi', phone: '880' },
    { code: 'BE', label: 'Belgian', phone: '32' },
    { code: 'BF', label: 'Burkinabe', phone: '226' },
    { code: 'BG', label: 'Bulgarian', phone: '359' },
    { code: 'BH', label: 'Bahraini', phone: '973' },
    { code: 'BI', label: 'Burundian', phone: '257' },
    { code: 'BJ', label: 'Beninese', phone: '229' },
    { code: 'BL', label: 'Saint Barthelemy', phone: '590' },
    { code: 'BM', label: 'Bermudian', phone: '1-441' },
    { code: 'BN', label: 'Bruneian', phone: '673' },
    { code: 'BO', label: 'Bolivian', phone: '591' },
    { code: 'BR', label: 'Brazilian', phone: '55' },
    { code: 'BS', label: 'Bahamian', phone: '1-242' },
    { code: 'BT', label: 'Bhutanese', phone: '975' },
    { code: 'BV', label: 'Bouvet Island', phone: '47' },
    { code: 'BW', label: 'Botswanan', phone: '267' },
    { code: 'BY', label: 'Belarusian', phone: '375' },
    { code: 'BZ', label: 'Belizean', phone: '501' },
    {
        code: 'CA',
        label: 'Canadian',
        phone: '1',
        suggested: true,
    },
    {
        code: 'CC',
        label: 'Cocos Island',
        phone: '61',
    },
    {
        code: 'CD',
        label: 'Congolese',
        phone: '243',
    },
    {
        code: 'CF',
        label: 'Central African',
        phone: '236',
    },
    {
        code: 'CG',
        label: 'Congolese',
        phone: '242',
    },
    { code: 'CH', label: 'Swiss', phone: '41' },
    { code: 'CI', label: 'Ivorian', phone: '225' },
    { code: 'CK', label: 'Cook Island', phone: '682' },
    { code: 'CL', label: 'Chilean', phone: '56' },
    { code: 'CM', label: 'Cameroonian', phone: '237' },
    { code: 'CN', label: 'Chinese', phone: '86' },
    { code: 'CO', label: 'Colombian', phone: '57' },
    { code: 'CR', label: 'Costa Rican', phone: '506' },
    { code: 'CU', label: 'Cuban', phone: '53' },
    { code: 'CV', label: 'Cape Verdean', phone: '238' },
    { code: 'CW', label: 'Curacaoan', phone: '599' },
    { code: 'CX', label: 'Christmas Island', phone: '61' },
    { code: 'CY', label: 'Cypriot', phone: '357' },
    { code: 'CZ', label: 'Czech', phone: '420' },
    { code: 'DE', label: 'German', phone: '49' },
    { code: 'DJ', label: 'Djiboutian', phone: '253' },
    { code: 'DK', label: 'Danish', phone: '45' },
    { code: 'DM', label: 'Dominican', phone: '1-767' },
    { code: 'DO', label: 'Dominican', phone: '1-809 and 1-829' },
    { code: 'DZ', label: 'Algerian', phone: '213' },
    { code: 'EC', label: 'Ecuadorean', phone: '593' },
    { code: 'EE', label: 'Estonian', phone: '372' },
    { code: 'EG', label: 'Egyptian', phone: '20' },
    { code: 'EH', label: 'Western Saharan', phone: '212' },
    { code: 'ER', label: 'Eritrean', phone: '291' },
    { code: 'ES', label: 'Spanish', phone: '34' },
    { code: 'ET', label: 'Ethiopian', phone: '251' },
    { code: 'FI', label: 'Finnish', phone: '358' },
    { code: 'FJ', label: 'Fijian', phone: '679' },
    { code: 'FK', label: 'Falkland Island', phone: '500' },
    { code: 'FM', label: 'Micronesian', phone: '691' },
    { code: 'FO', label: 'Faroe Island', phone: '298' },
    { code: 'FR', label: 'French', phone: '33' },
    { code: 'GA', label: 'Gabonese', phone: '241' },
    { code: 'GB', label: 'British', phone: '44' },
    { code: 'GD', label: 'Grenadian', phone: '1-473' },
    { code: 'GE', label: 'Georgian', phone: '995' },
    { code: 'GF', label: 'French Guianese', phone: '594' },
    { code: 'GG', label: 'Guernsey', phone: '44' },
    { code: 'GH', label: 'Ghanaian', phone: '233' },
    { code: 'GI', label: 'Gibraltar', phone: '350' },
    { code: 'GL', label: 'Greenland', phone: '299' },
    { code: 'GM', label: 'Gambian', phone: '220' },
    { code: 'GN', label: 'Guinean', phone: '224' },
    { code: 'GP', label: 'Guadeloupe', phone: '590' },
    { code: 'GQ', label: 'Equatorial Guinean', phone: '240' },
    { code: 'GR', label: 'Greek', phone: '30' },
    { code: 'GS', label: 'South Georgia and the South Sandwich Islands', phone: '500' },
    { code: 'GT', label: 'Guatemalan', phone: '502' },
    { code: 'GU', label: 'Guamanian', phone: '1-671' },
    { code: 'GW', label: 'Guinean', phone: '245' },
    { code: 'GY', label: 'Guyanese', phone: '592' },
    { code: 'HK', label: 'Hong Kong', phone: '852' },
    { code: 'HM', label: 'Heard Island and McDonald Islands', phone: '672' },
    { code: 'HN', label: 'Honduran', phone: '504' },
    { code: 'HR', label: 'Croatian', phone: '385' },
    { code: 'HT', label: 'Haitian', phone: '509' },
    { code: 'HU', label: 'Hungarian', phone: '36' },
    { code: 'ID', label: 'Indonesian', phone: '62' },
    { code: 'IE', label: 'Irish', phone: '353' },
    { code: 'IL', label: 'Israeli', phone: '972' },
    { code: 'IM', label: 'Man Island', phone: '44' },
    { code: 'IN', label: 'Indian', phone: '91' },
    { code: 'IO', label: 'British Indian Ocean Territory', phone: '246' },
    { code: 'IQ', label: 'Iraqi', phone: '964' },
    { code: 'IR', label: 'Iranian', phone: '98' },
    { code: 'IS', label: 'Icelandic', phone: '354' },
    { code: 'IT', label: 'Italian', phone: '39' },
    { code: 'JE', label: 'Jersey', phone: '44' },
    { code: 'JM', label: 'Jamaican', phone: '1-876' },
    { code: 'JO', label: 'Jordanian', phone: '962' },
    { code: 'JP', label: 'Japanese', phone: '81' },
    { code: 'KE', label: 'Kenyan', phone: '254' },
    { code: 'KG', label: 'Kyrgyzstani', phone: '996' },
    { code: 'KH', label: 'Cambodian', phone: '855' },
    { code: 'KI', label: 'Kiribati', phone: '686' },
    { code: 'KM', label: 'Comoran', phone: '269' },
    { code: 'KN', label: 'Kittian and Nevisian', phone: '1-869' },
    { code: 'KP', label: 'North Korean', phone: '850' },
    { code: 'KR', label: 'South Korean', phone: '82' },
    { code: 'KW', label: 'Kuwaiti', phone: '965' },
    { code: 'KY', label: 'Cayman Island', phone: '1-345' },
    { code: 'KZ', label: 'Kazakhstani', phone: '7' },
    { code: 'LA', label: 'Lao', phone: '856' },
    { code: 'LB', label: 'Lebanese', phone: '961' },
    { code: 'LC', label: 'Saint Lucian', phone: '1-758' },
    { code: 'LI', label: 'Liechtenstein', phone: '423' },
    { code: 'LK', label: 'Sri Lankan', phone: '94' },
    { code: 'LR', label: 'Liberian', phone: '231' },
    { code: 'LS', label: 'Lesotho', phone: '266' },
    { code: 'LT', label: 'Lithuanian', phone: '370' },
    { code: 'LU', label: 'Luxembourgish', phone: '352' },
    { code: 'LV', label: 'Latvian', phone: '371' },
    { code: 'LY', label: 'Libyan', phone: '218' },
    { code: 'MA', label: 'Moroccan', phone: '212' },
    { code: 'MC', label: 'Monacan', phone: '377' },
    { code: 'MD', label: 'Moldovan', phone: '373' },
    { code: 'ME', label: 'Montenegrin', phone: '382' },
    { code: 'MF', label: 'Saint Martin', phone: '590' },
    { code: 'MG', label: 'Malagasy', phone: '261' },
    { code: 'MH', label: 'Marshallese', phone: '692' },
    { code: 'MK', label: 'Macedonian', phone: '389' },
    { code: 'ML', label: 'Malian', phone: '223' },
    { code: 'MM', label: 'Myanmarese', phone: '95' },
    { code: 'MN', label: 'Mongolian', phone: '976' },
    { code: 'MO', label: 'Macau', phone: '853' },
    { code: 'MP', label: 'Northern Mariana Island', phone: '1-670' },
    { code: 'MQ', label: 'Martiniquais', phone: '596' },
    { code: 'MR', label: 'Mauritanian', phone: '222' },
    { code: 'MS', label: 'Montserrat', phone: '1-664' },
    { code: 'MT', label: 'Maltese', phone: '356' },
    { code: 'MU', label: 'Mauritian', phone: '230' },
    { code: 'MV', label: 'Maldivian', phone: '960' },
    { code: 'MW', label: 'Malawian', phone: '265' },
    { code: 'MX', label: 'Mexican', phone: '52' },
    { code: 'MY', label: 'Malaysian', phone: '60' },
    { code: 'MZ', label: 'Mozambican', phone: '258' },
    { code: 'NA', label: 'Namibian', phone: '264' },
    { code: 'NC', label: 'New Caledonian', phone: '687' },
    { code: 'NE', label: 'Nigerien', phone: '227' },
    { code: 'NF', label: 'Norfolk Island', phone: '672' },
    { code: 'NG', label: 'Nigerian', phone: '234' },
    { code: 'NI', label: 'Nicaraguan', phone: '505' },
    { code: 'NL', label: 'Dutch', phone: '31' },
    { code: 'NO', label: 'Norwegian', phone: '47' },
    { code: 'NP', label: 'Nepalese', phone: '977' },
    { code: 'NR', label: 'Nauruan', phone: '674' },
    { code: 'NU', label: 'Niue', phone: '683' },
    { code: 'NZ', label: 'New Zealand', phone: '64' },
    { code: 'OM', label: 'Omani', phone: '968' },
    { code: 'PA', label: 'Panamanian', phone: '507' },
    { code: 'PE', label: 'Peruvian', phone: '51' },
    { code: 'PF', label: 'French Polynesian', phone: '689' },
    { code: 'PG', label: 'Papua New Guinean', phone: '675' },
    { code: 'PH', label: 'Philippine', phone: '63' },
    { code: 'PK', label: 'Pakistani', phone: '92' },
    { code: 'PL', label: 'Polish', phone: '48' },
    { code: 'PM', label: 'Saint Pierre and Miquelon', phone: '508' },
    { code: 'PN', label: 'Pitcairn', phone: '870' },
    { code: 'PR', label: 'Puerto Rican', phone: '1-787 and 1-939' },
    { code: 'PS', label: 'Palestinian', phone: '970' },
    { code: 'PT', label: 'Portuguese', phone: '351' },
    { code: 'PW', label: 'Palauan', phone: '680' },
    { code: 'PY', label: 'Paraguayan', phone: '595' },
    { code: 'QA', label: 'Qatari', phone: '974' },
    { code: 'RE', label: 'Reunion', phone: '262' },
    { code: 'RO', label: 'Romanian', phone: '40' },
    { code: 'RS', label: 'Serbian', phone: '381' },
    { code: 'RU', label: 'Russian', phone: '7' },
    { code: 'RW', label: 'Rwandan', phone: '250' },
    { code: 'SA', label: 'Saudi Arabian', phone: '966' },
    { code: 'SB', label: 'Solomon Island', phone: '677' },
    { code: 'SC', label: 'Seychellois', phone: '248' },
    { code: 'SD', label: 'Sudanese', phone: '249' },
    { code: 'SE', label: 'Swedish', phone: '46' },
    { code: 'SG', label: 'Singaporean', phone: '65' },
    { code: 'SH', label: 'Saint Helenian', phone: '290' },
    { code: 'SI', label: 'Slovenian', phone: '386' },
    { code: 'SJ', label: 'Svalbard and Jan Mayen', phone: '47' },
    { code: 'SK', label: 'Slovak', phone: '421' },
    { code: 'SL', label: 'Sierra Leonean', phone: '232' },
    { code: 'SM', label: 'San Marinese', phone: '378' },
    { code: 'SN', label: 'Senegalese', phone: '221' },
    { code: 'SO', label: 'Somali', phone: '252' },
    { code: 'SR', label: 'Surinamese', phone: '597' },
    { code: 'SS', label: 'South Sudanese', phone: '211' },
    { code: 'ST', label: 'Sao Tomean', phone: '239' },
    { code: 'SV', label: 'Salvadoran', phone: '503' },
    { code: 'SX', label: 'Sint Maarten', phone: '1-721' },
    { code: 'SY', label: 'Syrian', phone: '963' },
    { code: 'TJ', label: 'Tajikistani', phone: '992' },
    { code: 'TK', label: 'Tokelau', phone: '690' },
    { code: 'TL', label: 'East Timorese', phone: '670' },
    { code: 'TM', label: 'Turkmen', phone: '993' },
    { code: 'TN', label: 'Tunisian', phone: '216' },
    { code: 'TO', label: 'Tongan', phone: '676' },
    { code: 'TR', label: 'Turkish', phone: '90' },
    { code: 'TT', label: 'Trinidadian/Tobagonian', phone: '1-868' },
    { code: 'TV', label: 'Tuvaluan', phone: '688' },
    { code: 'TW', label: 'Taiwanese', phone: '886' },
    { code: 'TZ', label: 'Tanzanian', phone: '255' },
    { code: 'UA', label: 'Ukrainian', phone: '380' },
    { code: 'UG', label: 'Ugandan', phone: '256' },
    { code: 'UM', label: 'US Minor Outlying Islands', phone: '1' },
    { code: 'US', label: 'American', phone: '1', suggested: true },
    { code: 'UY', label: 'Uruguayan', phone: '598' },
    { code: 'UZ', label: 'Uzbekistani', phone: '998' },
    { code: 'VA', label: 'Vatican', phone: '379' },
    { code: 'VC', label: 'Saint Vincent and the Grenadines', phone: '1-784' },
    { code: 'VE', label: 'Venezuelan', phone: '58' },
    { code: 'VG', label: 'British Virgin Island', phone: '1-284' },
    { code: 'VI', label: 'US Virgin Island', phone: '1-340' },
    { code: 'VN', label: 'Vietnamese', phone: '84' },
    { code: 'VU', label: 'Vanuatu', phone: '678' },
    { code: 'WF', label: 'Wallis and Futuna', phone: '681' },
    { code: 'WS', label: 'Samoan', phone: '685' },
    { code: 'XK', label: 'Kosovo', phone: '383' },
    { code: 'YE', label: 'Yemeni', phone: '967' },
    { code: 'YT', label: 'Mayotte', phone: '262' },
    { code: 'ZA', label: 'South African', phone: '27' },
    { code: 'ZM', label: 'Zambian', phone: '260' },
    { code: 'ZW', label: 'Zimbabwean', phone: '263' },
]